export enum SourceMimeTypes {
    aac = 'audio/aac',
    mp4 = 'video/mp4',
    f4v = 'video/x-f4v',
    f4a = 'audio/x-f4a',
    m4v = 'video/m4v',
    mov = 'video/quicktime',
    mp3 = 'audio/mp3',
    mpeg = 'video/mpeg',
    ogv = 'video/ogg',
    ogg = 'audio/ogg',
    oga = 'audio/ogg',
    vorbis = 'audio/ogg',
    m3u8 = 'application/x-mpegURL',
    m3u = 'application/x-mpegURL',
    hls = 'application/x-mpegURL',
    dash = 'application/dash+xml'
}
